import React from 'react'
import { Route } from "react-router-dom"
import SearchFeature from './SearchFeature'
import SearchGwas from './SearchGwas'
import SearcheGwas from './SearcheGwas'
import SearchSnpIndel from './SearchSnpIndel'
import SearchSv from './SearchSv'
import SearchMarker from './SearchMarker'
import SearchQTL from './SearchQTL'
import SearchHaplotype from './SearchHaplotype'
import SearchCrispr from './SearchCrispr'
import SearchTrait from './SearchTrait'
import SearchSite from './SearchSite'

import './search.css'


class Search extends React.Component {
    render() {
        return (
			<React.Fragment>
				<Route path="/search/site/:value">
					<SearchSite />
				</Route>
				<Route path="/search/feature">
					<SearchFeature />
				</Route>
				<Route path="/search/gwas">
					<SearchGwas />
				</Route>
				<Route path="/search/egwas">
					<SearcheGwas />
				</Route>
				<Route path="/search/snp_indel">
					<SearchSnpIndel />
				</Route>
				<Route path="/search/sv">
					<SearchSv />
				</Route>
				<Route path="/search/marker">
					<SearchMarker />
				</Route>
				<Route path="/search/qtl">
					<SearchQTL />
				</Route>
				<Route path="/search/haplotype">
					<SearchHaplotype />
				</Route>
				<Route path="/search/crispr">
					<SearchCrispr />
				</Route>
				<Route path="/search/trait">
					<SearchTrait />
				</Route>
            </React.Fragment>
        )
    }
}

export default Search
